import AuthIpcRouter, {
  type AuthIpcRouterType,
  type SwitchOrganizationResult,
} from '@shared/ipc/routers/AuthIpc.router'

class AuthIpcRenderer extends AuthIpcRouter implements AuthIpcRouterType {
  async getAuthProvider(): Promise<'workos' | 'supabase'> {
    return this.exec('getAuthProvider')
  }

  async getAccessToken(): Promise<string> {
    return this.exec('getAccessToken')
  }

  async signOut(): Promise<void> {
    return this.exec('signOut')
  }

  async handleUnauthorized(rejectedToken?: string): Promise<string | null> {
    return this.exec('handleUnauthorized', rejectedToken)
  }

  async switchOrganization(organizationId: string): Promise<SwitchOrganizationResult> {
    return this.exec('switchOrganization', organizationId)
  }

  async getConnectUrlForProvider(
    provider: string,
    options?: { microsoftTenant?: 'common' | 'organizations' | 'consumers'; connectionId?: string },
  ): Promise<string> {
    return this.exec('getConnectUrlForProvider', { provider, options })
  }
}

export default new AuthIpcRenderer()
